import { getPersonalSettings, updatePersonalSettings } from "@common-store/personal-settings"
import { Debouncer } from "./index"

export default {
    data() {
        return {
            sidebarWidth: 300,
            isResizing: false,
            minWidth: 250,
            maxWidth: document.body.clientWidth / 2,
            resizeKey: "sidebarWidth",
            debouncer: new Debouncer()
        }
    },
    created() {
        if (getPersonalSettings(this.resizeKey)) {
            this.sidebarWidth = getPersonalSettings(this.resizeKey)
        }
    },
    methods: {
        startResize(e) {
            this.isResizing = true

            this.initialX = e.clientX || (e.touches && e.touches[0].clientX)
            this.initialWidth = this.sidebarWidth

            document.addEventListener("mousemove", this.resize)
            document.addEventListener("mouseup", this.stopResize)

            document.addEventListener("touchmove", this.resize)
            document.addEventListener("touchend", this.stopResize)

            document.body.style.userSelect = "none"
        },
        resize(e) {
            if (!this.isResizing) return

            const currentX = e.clientX || (e.touches && e.touches[0].clientX)
            const deltaX = currentX - this.initialX
            const newWidth = this.initialWidth + deltaX

            if (newWidth >= this.minWidth && newWidth <= this.maxWidth) {
                this.sidebarWidth = newWidth
                this.debouncer.exec(() => {
                    updatePersonalSettings(this.resizeKey, newWidth)
                }, 100)
            }
        },
        stopResize() {
            this.isResizing = false

            document.removeEventListener("mousemove", this.resize)
            document.removeEventListener("mouseup", this.stopResize)

            document.removeEventListener("touchmove", this.resize)
            document.removeEventListener("touchend", this.stopResize)

            document.body.style.userSelect = ""
        }
    }
}
